import React from 'react';
import {FormattedMessage} from 'react-intl';
import {useGlobalContext} from '../../../../common/components/core/GlobalContext';
import {useListUnreadMessagesContext} from '../ListUnreadMessagesContext';
import UnreadMessage from '../UnreadMessage';
import LocaleSelector from '../../../../common/components/core/LocaleSelector';
import ButtonAction from '../../../../common/components/ui/ButtonAction';
import logo from '../../../../common/assets/logo@3x.png';
import left from '../../../../common/assets/icons/chevron-left.svg';
import right from '../../../../common/assets/icons/chevron-right.svg';
import styles from './ListUnreadMessages.module.scss';

const ListUnreadMessages = () => {
  const {
    closePopup,
    page, nextPage, prevPage,
    messages, currentMessage,
    markMessages
  } = useListUnreadMessagesContext();
  const {layoutDirection} = useGlobalContext();

  const handleReadOne = () => {
    if (currentMessage) {
      markMessages([currentMessage._id]);
    }
  }

  const handleReadAll = () => {
    markMessages(messages.map(item => item._id));
    closePopup();
  };

  return (
    <div className={styles.listUnreadMessagesContainer} dir={layoutDirection}>
      <div className={styles.header}>
        <LocaleSelector/>
        <img src={logo} alt="logo" className={styles.logo}/>
        <div className={styles.pages}>
          <FormattedMessage
            id={'dashboard-popup-unread-messages-pages'}
            defaultMessage={'Page {page}/{pages}'}
            values={{
              page: page + 1,
              pages: messages.length
            }}
          />
        </div>
      </div>
      <div className={styles.messageContainer}>
        <UnreadMessage/>
      </div>
      <div className={styles.buttonsContainer}>
        <ButtonAction
          variant={'icon'}
          icon={layoutDirection === 'ltr' ? left : right}
          customClassnames={{
            icon: styles.iconChevron,
            container: styles.iconContainer
          }}
          onClick={prevPage}
          disabled={page === 0}
        />
        <div className={styles.readContainer}>
          <ButtonAction
            label={
              <FormattedMessage
                id={'dashboard-popup-unread-messages-button-read'}
                defaultMessage={'Read'}
              />
            }
            customClassnames={{container: styles.buttonRead}}
            onClick={handleReadOne}
          />
          <ButtonAction
            label={
              <FormattedMessage
                id={'dashboard-popup-unread-messages-button-read-all'}
                defaultMessage={'Read all'}
              />
            }
            onClick={handleReadAll}
            customClassnames={{container: styles.buttonRead}}
          />
        </div>
        <ButtonAction
          variant={'icon'}
          icon={layoutDirection === 'ltr' ? right : left}
          customClassnames={{
            icon: styles.iconChevron,
            container: styles.iconContainer
          }}
          onClick={nextPage}
          disabled={page === messages.length - 1}
        />
      </div>
    </div>
  );
};

export default ListUnreadMessages;
